import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { useRouteMatch, useLocation } from '@fs/zion-router'

import { useCurrentVendor, companiesExcludedInChat } from '../VendorProvider'
import { Chat } from '../../global/chatSettingsConfig'

export const ChatOverlayContext = createContext()

export const useChatOverlayContext = () => useContext(ChatOverlayContext)

export function ChatOverlayProvider({ appHistory, children }) {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const routeMatch = useRouteMatch('/speakers/:id')
  const onVirtualBooth = useRouteMatch('/expohall/:sponsorId')
  const isSupportPage = location.pathname === '/volunteer/support'

  const { data: vendorQueryData } = useCurrentVendor()
  const vendorData = vendorQueryData?.ExhibitorPage
  const shouldRouteToAskAnExpert = vendorData && onVirtualBooth && !companiesExcludedInChat.includes(vendorData.name)

  const toggleChatOverlay = useCallback(() => {
    setIsOpen((curr) => !curr)

    // NOTE: launch to the Chat Rooms tab if the main page is on a session
    if (location.pathname.startsWith('/session')) {
      window.chatHistory.push('/connect/rooms')
    }

    // open to ask an expert
    if (Chat.Settings.ASK_EXPERT_ENABLED && shouldRouteToAskAnExpert) {
      const { name, contentId } = vendorData
      if (name && contentId) {
        window.chatHistory.push(`/ask-an-expert/${name}/${contentId}`)
      }
    }
  }, [location.pathname, shouldRouteToAskAnExpert, vendorData])

  // the only time we should force the user to a different chat page is when they are on ask-an-expert outside
  // of a valid booth. Sine the context is gone, they should not be there anymore
  useEffect(() => {
    if (
      Chat.Settings.ASK_EXPERT_ENABLED &&
      !shouldRouteToAskAnExpert &&
      window.chatHistory?.location.pathname.startsWith('/ask-an-expert/')
    ) {
      window.chatHistory.push('/')
    }
  }, [shouldRouteToAskAnExpert])

  return (
    <ChatOverlayContext.Provider
      value={{
        isOpen,
        setIsOpen,
        toggleChatOverlay,
        speaker: routeMatch ? routeMatch.params.id : undefined,
        onVirtualBooth,
        appHistory,
        isSupportPage,
      }}
    >
      {children}
    </ChatOverlayContext.Provider>
  )
}
